import { React, Component, Link, _ } from 'utils';
import { App, SelectedPavilionStore } from 'model';
import './chat.less';

export default class Chat extends Component {
	render() {
		var { data, stand } = this.props;
		var { standElement:element } = data;

		var scss = ['status'];
		var msg = '';
		var action = '';

		if(stand.chatOnline == '0') {
			scss.push('offline');
			msg = stand.chatOfflineMessage;
			action = _('Leave a message')
		} else {
			scss.push('online');
			msg = stand.chatOnlineMessage;
			action = _('Chat with us')
		}

		var style = {
			width: element.width,
			height: element.height
		}

		var filename = App.filename(element.imageUrl);
		var css = ['chat', filename];

		var pavilion = SelectedPavilionStore.getSelectedPavilionSlug();
		var chatUrl = `/pavilion/${pavilion}/stand/${stand.slug}/chat`;

		return <div className={ css.join(' ') }>
			<div className="bubble-container">
				<div className="bubble">
					<div className="body">
						<div className="msg">{ msg }</div>
						<Link to={ chatUrl } className="action">
							<span className={ scss.join(' ') }></span>
							<span className="type">{ action }</span>
						</Link>
					</div>
				</div>
			</div>

			<img src={ element.imageUrl } style={ style } />
		</div>
	}
}



// WEBPACK FOOTER //
// ./src/modules/components/elements/chat.js